export default __webpack_public_path__ + "static/media/Skirmisher's Crossbow.329ee4c8.jpg";